/* ══════════════════════════════════════════════════════════════════════════
   Lejan — Match Builder
   Estado → render → eventos. Sin framework, sin dependencias.

   Máquina de estados del panel (mismos valores que las variantes de Figma):
     empty-adult · empty-kid · adult-filled · adult-filled-kid-active · full
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var SELECTOR = 'section-lej-match';

  function formatMoney(cents) {
    var cur = (window.Shopify && window.Shopify.currency) || {};
    var rate = parseFloat(cur.rate || '1') || 1;
    var amount = (cents * rate) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: cur.active || 'EUR'
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function MatchBuilder(root) {
    this.root = root;
    this.grid = root.querySelector('.match__grid');
    this.panel = root.querySelector('.match__panel');
    this.cta = root.querySelector('[data-match-cta]');
    this.ctaLabel = this.cta.querySelector('.cta__label');
    this.errorBox = root.querySelector('[data-match-error]');
    this.slots = {
      adult: root.querySelector('.match-slot[data-slot="adult"]'),
      kid: root.querySelector('.match-slot[data-slot="kid"]')
    };

    this.strings = {
      empty: this.cta.getAttribute('data-label-empty') || '',
      ready: this.cta.getAttribute('data-label-ready') || '',
      adding: this.cta.getAttribute('data-label-adding') || '',
      remove: this.cta.getAttribute('data-label-remove') || '',
      errorGeneric: this.errorBox.getAttribute('data-error-generic') || '',
      errorSoldOut: this.errorBox.getAttribute('data-error-sold-out') || ''
    };

    this.enableSuggestion = root.getAttribute('data-enable-suggestion') === 'true';

    this.state = {
      activeTarget: 'adult',
      adult: null,
      kid: null,
      busy: false
    };

    this.bind();
    this.render();
  }

  /* ── Datos de una card ───────────────────────────────────── */
  MatchBuilder.prototype.readCard = function (card) {
    if (card.__matchData) return card.__matchData;
    var holder = card.querySelector('.match-card__data');
    if (!holder) return null;
    try {
      card.__matchData = JSON.parse(holder.textContent);
    } catch (e) {
      return null;
    }
    return card.__matchData;
  };

  /* ── Selector de talla (mismo componente que el sticky de la PDP) ────
     El <select> nativo sigue siendo la fuente de verdad: la lista solo lo
     escribe y dispara `change`, así que el resto del builder no se entera. */
  MatchBuilder.prototype.closeAllSizes = function (except) {
    var lists = this.root.querySelectorAll('.m-size__list');
    for (var i = 0; i < lists.length; i++) {
      if (lists[i] === except) continue;
      lists[i].hidden = true;
      var btn = lists[i].parentNode.querySelector('.m-size__btn');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  };

  MatchBuilder.prototype.toggleSize = function (btn) {
    var wrap = btn.closest('.m-size');
    var list = wrap.querySelector('.m-size__list');
    var open = list.hidden;
    this.closeAllSizes(open ? list : null);
    list.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  MatchBuilder.prototype.pickSize = function (opt) {
    var wrap = opt.closest('.m-size');
    var native = wrap.querySelector('.m-size__native');
    native.value = opt.getAttribute('data-id');
    this.syncSizeUI(wrap);
    this.closeAllSizes(null);
    native.dispatchEvent(new Event('change', { bubbles: true }));
  };

  /* Deja el botón y la lista mostrando lo que dice el <select> nativo */
  MatchBuilder.prototype.syncSizeUI = function (wrap) {
    var native = wrap.querySelector('.m-size__native');
    var current = wrap.querySelector('[data-m-size-current]');
    var opts = wrap.querySelectorAll('.m-size__opt');
    var chosen = native.options[native.selectedIndex];
    if (chosen && current) current.textContent = chosen.textContent;
    for (var i = 0; i < opts.length; i++) {
      var on = opts[i].getAttribute('data-id') === native.value;
      opts[i].classList.toggle('is-current', on);
      opts[i].setAttribute('aria-selected', on ? 'true' : 'false');
    }
  };

  /* Repinta la lista de un slot a partir de las variantes del producto colocado */
  MatchBuilder.prototype.fillSizeList = function (wrap, variants, variantId) {
    var native = wrap.querySelector('.m-size__native');
    var list = wrap.querySelector('.m-size__list');
    var btn = wrap.querySelector('.m-size__btn');
    native.innerHTML = '';
    list.innerHTML = '';
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      // Las tallas agotadas no se pintan en esta página (decisión de Hugo, 2026-08-19):
      // ni en el <select> nativo ni en la lista visible. La PDP no se toca.
      if (!v.available) continue;
      var o = document.createElement('option');
      o.value = v.id;
      o.textContent = v.title;
      native.appendChild(o);

      var li = document.createElement('li');
      li.className = 'm-size__opt';
      li.setAttribute('role', 'option');
      li.setAttribute('data-id', String(v.id));
      var label = document.createElement('span');
      label.className = 'm-size__opt-label';
      label.textContent = v.title;
      li.appendChild(label);
      list.appendChild(li);
    }
    // Con las agotadas fuera, la variante que traiga el producto puede no estar en la lista:
    // en ese caso se cae a la primera disponible en vez de dejar el select sin selección.
    native.value = String(variantId);
    if (native.selectedIndex < 0 && native.options.length) native.selectedIndex = 0;
    native.disabled = false;
    btn.disabled = false;
    this.syncSizeUI(wrap);
  };

  /* ── Eventos ─────────────────────────────────────────────── */
  MatchBuilder.prototype.bind = function () {
    var self = this;

    // a) Tabs (las del grid y las del panel comparten data-match-tab)
    this.root.addEventListener('click', function (ev) {
      var sizeBtn = ev.target.closest('.m-size__btn');
      if (sizeBtn && self.root.contains(sizeBtn)) {
        self.toggleSize(sizeBtn);
        return;
      }

      var sizeOpt = ev.target.closest('.m-size__opt');
      if (sizeOpt && self.root.contains(sizeOpt)) {
        self.pickSize(sizeOpt);
        return;
      }

      self.closeAllSizes(null);

      var tab = ev.target.closest('[data-match-tab]');
      if (tab && self.root.contains(tab)) {
        self.setTarget(tab.getAttribute('data-match-tab'));
        return;
      }

      // b) Colocar: el "+" de la imagen y el botón de acción hacen lo mismo
      var place = ev.target.closest('[data-match-place]');
      if (place && self.root.contains(place)) {
        var card = place.closest('.match-card');
        if (card) self.placeFromCard(card);
        return;
      }

      // d) Quitar del slot
      var remove = ev.target.closest('[data-match-remove]');
      if (remove && self.root.contains(remove)) {
        var slot = remove.closest('.match-slot');
        if (slot) self.clearSlot(slot.getAttribute('data-slot'));
        return;
      }

      // e) CTA
      var cta = ev.target.closest('[data-match-cta]');
      if (cta && self.root.contains(cta)) self.addToCart();
    });

    document.addEventListener('click', function (ev) {
      if (!self.root.contains(ev.target)) self.closeAllSizes(null);
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') self.closeAllSizes(null);
    });

    // c) Tallas — en la card (atajo) y en el slot (la que manda)
    this.root.addEventListener('change', function (ev) {
      var cardSize = ev.target.closest('[data-match-size]');
      if (cardSize) {
        self.syncSizeUI(cardSize.closest('.m-size'));
        var card = cardSize.closest('.match-card');
        var data = card && self.readCard(card);
        if (!data) return;
        // Si ese producto ya está colocado, la card sincroniza el slot
        var slotKey = data.target;
        var chosen = self.state[slotKey];
        if (chosen && chosen.productId === data.id) {
          self.setVariant(slotKey, parseInt(cardSize.value, 10));
        }
        return;
      }

      var slotSize = ev.target.closest('[data-match-slot-size]');
      if (slotSize) {
        var slot = slotSize.closest('.match-slot');
        self.setVariant(slot.getAttribute('data-slot'), parseInt(slotSize.value, 10));
      }
    });
  };

  /* ── Target activo (qué colección se mira / qué slot recibe) ─ */
  MatchBuilder.prototype.setTarget = function (target) {
    if (target !== 'adult' && target !== 'kid') return;
    this.state.activeTarget = target;
    this.render();
  };

  /* ── Colocar un producto ─────────────────────────────────── */
  /* En móvil el panel de slots va ARRIBA (order: 1) y las tarjetas abajo, así que al
     colocar un producto el slot que se rellena queda fuera de pantalla y no hay feedback.
     Subimos el scroll al panel, descontando el header si está fijo o pegajoso. */
  MatchBuilder.prototype.revealPanel = function () {
    if (!this.panel) return;
    if (!window.matchMedia('(max-width: 767.98px)').matches) return;

    var offset = 0;
    var candidatos = document.querySelectorAll('header, .header, [data-sticky-header]');
    for (var i = 0; i < candidatos.length; i++) {
      var cs = window.getComputedStyle(candidatos[i]);
      if (cs.position === 'fixed' || cs.position === 'sticky') {
        offset = Math.max(offset, candidatos[i].getBoundingClientRect().height);
      }
    }

    var rect = this.panel.getBoundingClientRect();
    // Si el panel ya se ve entero por debajo del header, no movemos nada.
    if (rect.top >= offset && rect.bottom <= window.innerHeight) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var destino = window.pageYOffset + rect.top - offset - 12;
    window.scrollTo({ top: Math.max(0, destino), behavior: reduce ? 'auto' : 'smooth' });
  };

  MatchBuilder.prototype.placeFromCard = function (card) {
    var data = this.readCard(card);
    if (!data) return;

    var select = card.querySelector('[data-match-size]');
    var variantId = select ? parseInt(select.value, 10) : null;
    var variant = null;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].id === variantId) variant = data.variants[i];
    }
    if (!variant) {
      for (var j = 0; j < data.variants.length; j++) {
        if (!variant && data.variants[j].available) variant = data.variants[j];
      }
    }
    if (!variant) return;

    // Sustituye lo que hubiera (decisión de Hugo, 2026-08-18)
    this.state[data.target] = {
      productId: data.id,
      title: data.title,
      image: variant.image || data.featured,
      variantId: variant.id,
      variantTitle: variant.title,
      price: variant.price,
      variants: data.variants,
      matchKey: card.getAttribute('data-match-key') || ''
    };

    this.hideError();

    // Al colocar uno, el foco salta al hueco contrario si sigue vacío y se destaca su gemelo.
    // Simétrico en los dos sentidos (adulto → niño y niño → adulto).
    var other = data.target === 'adult' ? 'kid' : 'adult';
    if (!this.state[other]) {
      this.state.activeTarget = other;
      this.suggestTwin(this.state[data.target].matchKey, other);
    } else {
      this.clearSuggestion();
    }

    this.render();
    this.revealPanel();
  };

  MatchBuilder.prototype.setVariant = function (slotKey, variantId) {
    var chosen = this.state[slotKey];
    if (!chosen || !variantId) return;
    for (var i = 0; i < chosen.variants.length; i++) {
      if (chosen.variants[i].id === variantId) {
        chosen.variantId = variantId;
        chosen.variantTitle = chosen.variants[i].title;
        chosen.price = chosen.variants[i].price;
        chosen.image = chosen.variants[i].image || chosen.image;
      }
    }
    this.hideError();
    this.render();
  };

  MatchBuilder.prototype.clearSlot = function (slotKey) {
    this.state[slotKey] = null;
    this.state.activeTarget = slotKey;
    // Si el otro hueco sigue ocupado, se vuelve a recomendar su gemelo en el que queda libre
    var other = slotKey === 'adult' ? 'kid' : 'adult';
    if (this.state[other]) {
      this.suggestTwin(this.state[other].matchKey, slotKey);
    } else {
      this.clearSuggestion();
    }
    this.hideError();
    this.render();
  };

  /* ── f) Sugerencia: destaca, NO coloca (decisión 11) ─────── */
  MatchBuilder.prototype.suggestTwin = function (key, target) {
    this.clearSuggestion();
    if (!this.enableSuggestion || !key || !target) return;
    var twin = this.grid.querySelector(
      '.match-card[data-target="' + target + '"][data-match-key="' + key.replace(/"/g, '\\"') + '"]'
    );
    if (twin) twin.classList.add('is-suggested');
  };

  MatchBuilder.prototype.clearSuggestion = function () {
    var marked = this.grid.querySelectorAll('.match-card.is-suggested');
    for (var i = 0; i < marked.length; i++) marked[i].classList.remove('is-suggested');
  };

  /* ── Render ──────────────────────────────────────────────── */
  MatchBuilder.prototype.render = function () {
    var st = this.state;

    // Grid: qué colección se ve
    this.grid.setAttribute('data-active-target', st.activeTarget);

    // Tabs
    var tabs = this.root.querySelectorAll('[data-match-tab]');
    for (var i = 0; i < tabs.length; i++) {
      var isOn = tabs[i].getAttribute('data-match-tab') === st.activeTarget;
      tabs[i].classList.toggle('is-selected', isOn && tabs[i].classList.contains('match__tab'));
      tabs[i].classList.toggle('is-active', isOn && tabs[i].classList.contains('panel__tab'));
      tabs[i].setAttribute('aria-selected', isOn ? 'true' : 'false');
    }

    // Slots
    this.renderSlot('adult');
    this.renderSlot('kid');

    // Estado del panel
    var state;
    if (st.adult && st.kid) {
      state = 'full';
    } else if (st.adult) {
      state = st.activeTarget === 'kid' ? 'adult-filled-kid-active' : 'adult-filled';
    } else {
      state = st.activeTarget === 'kid' ? 'empty-kid' : 'empty-adult';
    }
    this.panel.setAttribute('data-state', state);

    // CTA
    var ready = !!(st.adult && st.kid && st.adult.variantId && st.kid.variantId);
    if (st.busy) {
      this.cta.setAttribute('data-state', 'disabled');
      this.cta.disabled = true;
      this.ctaLabel.textContent = this.strings.adding;
    } else if (ready) {
      var total = formatMoney(st.adult.price + st.kid.price);
      this.cta.setAttribute('data-state', 'ready');
      this.cta.disabled = false;
      this.ctaLabel.textContent = this.strings.ready.replace('__PRICE__', total);
    } else {
      this.cta.setAttribute('data-state', 'disabled');
      this.cta.disabled = true;
      this.ctaLabel.textContent = this.strings.empty;
    }
  };

  MatchBuilder.prototype.renderSlot = function (slotKey) {
    var slot = this.slots[slotKey];
    if (!slot) return;
    var chosen = this.state[slotKey];
    var img = slot.querySelector('.slot__image-media');
    var title = slot.querySelector('.slot__title');
    var select = slot.querySelector('[data-match-slot-size]');
    var remove = slot.querySelector('[data-match-remove]');

    var wrap = select.closest('.m-size');
    if (!chosen) {
      slot.setAttribute('data-state', this.state.activeTarget === slotKey ? 'active' : 'empty');
      img.setAttribute('hidden', '');
      img.removeAttribute('src');
      img.alt = '';
      title.textContent = '';
      select.innerHTML = '';
      select.disabled = true;
      select.removeAttribute('data-product-id');
      wrap.querySelector('.m-size__list').innerHTML = '';
      wrap.querySelector('.m-size__btn').disabled = true;
      return;
    }

    slot.setAttribute('data-state', 'filled');
    img.src = chosen.image || '';
    img.alt = chosen.title;
    img.removeAttribute('hidden');
    title.textContent = chosen.title;
    if (this.strings.remove) {
      remove.setAttribute('aria-label', this.strings.remove.replace('__PRODUCT__', chosen.title));
    }

    // Repintar tallas solo si cambió el producto
    if (select.getAttribute('data-product-id') !== String(chosen.productId)) {
      this.fillSizeList(wrap, chosen.variants, chosen.variantId);
      select.setAttribute('data-product-id', String(chosen.productId));
    } else {
      select.value = String(chosen.variantId);
      this.syncSizeUI(wrap);
    }
  };

  /* ── Errores ─────────────────────────────────────────────── */
  MatchBuilder.prototype.showError = function (message) {
    this.errorBox.textContent = message;
    this.errorBox.removeAttribute('hidden');
  };

  MatchBuilder.prototype.hideError = function () {
    this.errorBox.textContent = '';
    this.errorBox.setAttribute('hidden', '');
  };

  /* ── e) Añadir al carrito ────────────────────────────────── */
  MatchBuilder.prototype.addToCart = function () {
    var self = this;
    var st = this.state;
    if (st.busy) return;
    if (!st.adult || !st.kid || !st.adult.variantId || !st.kid.variantId) return;

    var matchId = st.adult.variantId + '-' + st.kid.variantId;
    var items = [
      { id: st.adult.variantId, quantity: 1, properties: { _match_id: matchId } },
      { id: st.kid.variantId, quantity: 1, properties: { _match_id: matchId } }
    ];

    st.busy = true;
    this.hideError();
    this.render();

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        // fetch NO lanza en 4xx: hay que mirar r.ok a mano
        if (!r.ok) {
          return r.json().catch(function () { return {}; }).then(function (body) {
            var err = new Error('cart-add-failed');
            err.status = r.status;
            err.body = body;
            throw err;
          });
        }
        return r.json();
      })
      .then(function () {
        st.busy = false;
        self.render();
        // Decisión 4: la selección NO se vacía
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
      })
      .catch(function (err) {
        st.busy = false;
        self.render();
        var soldOut = err && err.status === 422;
        self.showError(soldOut ? self.strings.errorSoldOut : self.strings.errorGeneric);
      });
  };


  /* ── Arranque ────────────────────────────────────────────── */
  function init() {
    var roots = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].__matchBuilder) roots[i].__matchBuilder = new MatchBuilder(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de temas re-renderiza la sección al cambiar un setting
  document.addEventListener('shopify:section:load', init);
})();
